export const COMPETENCIES_STATEMENTS_REQUEST =
  "COMPETENCIES_STATEMENTS_REQUEST";
export const COMPETENCIES_STATEMENTS_SUCCESS =
  "COMPETENCIES_STATEMENTS_SUCCESS";
export const COMPETENCIES_STATEMENTS_FAIL = "COMPETENCIES_STATEMENTS_FAIL";
export const COMPETENCIES_STATEMENTS_CLEAR_ERRORS =
  "COMPETENCIES_STATEMENTS_CLEAR_ERRORS";
